(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["po-support-selector"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('po-support-selector')) {
  customElements.define('po-support-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('[data-model]'));
      this.buttons = Array.from(this.querySelectorAll('[data-power]'));
      this.select = this.querySelector('[data-power-select]');
      this.allowed = new Set(['all', ...this.buttons.map(b => b.dataset.power)]);
      this.key = 'po_power_' + this.dataset.manual.toLowerCase();
      this.buttons.forEach(button => button.addEventListener('click', () => this.filter(button.dataset.power, true)));
      this.select?.addEventListener('change', () => this.filter(this.select.value, true));
      this.restore = () => this.filter(new URLSearchParams(location.search).get(this.key) || 'all', false);
      window.addEventListener('pageshow', this.restore);
      window.addEventListener('popstate', this.restore);
      this.restore();
      this.querySelector('[data-filter-controls]')?.removeAttribute('hidden');
    }
    disconnectedCallback() {
      window.removeEventListener('pageshow', this.restore);
      window.removeEventListener('popstate', this.restore);
      this.initialized = false;
    }
    filter(requested, update) {
      const value = this.allowed.has(requested) ? requested : 'all';
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = value !== 'all' && card.dataset.watts !== value;
        if (!card.hidden) count++;
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.power === value)));
      if (this.select) this.select.value = value;
      const status = this.querySelector('[data-count]');
      if (status) status.textContent = count + ' ' + (count === 1 ? this.dataset.one : this.dataset.many);
      if (update) {
        const url = new URL(location.href);
        if (value === 'all') url.searchParams.delete(this.key); else url.searchParams.set(this.key, value);
        history.replaceState(history.state, '', url);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pop-pic-text-detail"] && !Shopify.designMode) return;
  try {
    
  if (!window.popPicTextDetailInitialized) {
    window.popPicTextDetailInitialized = true;

    const activateDetail = (detail) => {
      const section = detail.closest('[data-pop-pic-text-detail]');
      if (!section) return;

      const blockId = detail.dataset.blockId;

      section.querySelectorAll('[data-pop-pic-detail]').forEach((item) => {
        item.open = item === detail;
      });

      section.querySelectorAll('[data-pop-pic-media]').forEach((media) => {
        media.hidden = media.dataset.blockId !== blockId;
      });
    };

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('[data-pop-pic-summary]');
      if (!summary) return;

      event.preventDefault();
      const detail = summary.closest('[data-pop-pic-detail]');
      if (detail) activateDetail(detail);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const detail = event.target.closest('[data-pop-pic-detail]');
      if (detail) activateDetail(detail);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pop-spec-dual"] && !Shopify.designMode) return;
  try {
    
  if (!window.popSpecDualInitialized) {
    window.popSpecDualInitialized = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pop-spec-dual-toggle]');
      if (!button) return;

      const section = button.closest('[data-pop-spec-dual]');
      if (!section) return;

      const willExpand = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(willExpand));
      section.classList.toggle('is-expanded', willExpand);

      section.querySelectorAll('[data-pop-spec-extra]').forEach((row) => {
        row.hidden = !willExpand;
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popo-story-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('popo-build-comparison')) {
  customElements.define('popo-build-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.range = this.querySelector('[data-comparison-range]');
      this.buttons = [...this.querySelectorAll('[data-stage-button]')];
      this.figures = [...this.querySelectorAll('[data-stage]')];
      this.labels = Object.fromEntries(this.buttons.map(b => [b.dataset.stageButton, b.textContent.trim()]));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoEnabled = !this.motion.matches;
      this.visible = false;
      this.pointerInside = false;
      this.direction = -1;
      this.holdUntil = 0;
      this.setPosition(this.motion.matches ? 0 : 100, false);
      this.dataset.autoState = this.motion.matches ? 'reduced-motion' : 'waiting';
      this.range.addEventListener('input', () => {
        this.stopAnimation('manual');
        this.setPosition(Number(this.range.value), false);
      }, { signal });
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.stopAnimation('manual');
        this.setPosition(button.dataset.stageButton === 'during' ? 100 : 0, true);
      }, { signal }));
      this.addEventListener('pointerenter', () => {
        this.pointerInside = true;
        this.pauseAnimation('hover');
      }, { signal });
      this.addEventListener('pointerleave', () => {
        this.pointerInside = false;
        if (this.autoEnabled && this.visible) this.startAnimation();
      }, { signal });
      this.addEventListener('focusin', () => this.stopAnimation('focus'), { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAnimation('hidden');
        else if (this.autoEnabled && this.visible && !this.pointerInside) this.startAnimation();
      }, { signal });
      this.motion.addEventListener('change', event => {
        if (event.matches) {
          this.stopAnimation('reduced-motion');
          this.setPosition(0, false);
        }
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        if (!this.visible) this.pauseAnimation('offscreen');
        else if (this.autoEnabled && !this.pointerInside) this.startAnimation();
      }, { threshold: 0.15 });
      this.observer.observe(this.querySelector('.pw-comparison-stage'));
    }
    startAnimation() {
      if (this.running || !this.autoEnabled || !this.visible || document.hidden) return;
      this.running = true;
      this.dataset.autoState = 'looping';
      this.dataset.motionState = 'playing';
      if (this.position <= 0) this.direction = 1;
      if (this.position >= 100) this.direction = -1;
      this.lastTime = performance.now();
      this.holdUntil = this.lastTime + 600;
      const step = now => {
        if (!this.running) return;
        const dt = Math.min(now - this.lastTime, 80);
        this.lastTime = now;
        if (now >= this.holdUntil) {
          this.setPosition(this.position + this.direction * dt / 32, false);
          if (this.position === 0 || this.position === 100) {
            this.direction *= -1;
            this.holdUntil = now + 600;
          }
        }
        this.frame = requestAnimationFrame(step);
      };
      this.frame = requestAnimationFrame(step);
    }
    pauseAnimation(reason) {
      cancelAnimationFrame(this.frame);
      this.running = false;
      this.dataset.motionState = 'paused';
      if (this.autoEnabled) this.dataset.autoState = reason;
    }
    stopAnimation(reason) {
      this.pauseAnimation(reason);
      this.autoEnabled = false;
      this.dataset.autoState = reason;
    }
    setPosition(position, announce) {
      const value = Math.max(0, Math.min(100, position));
      this.position = value;
      const rounded = Math.round(value);
      const stage = value === 100 ? 'during' : value === 0 ? 'finished' : 'comparison';
      this.dataset.currentStage = stage;
      this.style.setProperty('--pw-comparison-position', value.toFixed(2) + '%');
      this.range.value = rounded;
      if (this.lastLabelValue !== rounded) {
        this.range.setAttribute('aria-valuetext', rounded + '% ' + this.labels.during + ', ' + (100 - rounded) + '% ' + this.labels.finished);
        this.lastLabelValue = rounded;
      }
      this.figures.forEach(figure => {
        const hidden = String(figure.dataset.stage === 'during' ? value === 0 : value === 100);
        if (figure.getAttribute('aria-hidden') !== hidden) figure.setAttribute('aria-hidden', hidden);
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.stageButton === stage)));
      if (announce) this.querySelector('[data-stage-status]').textContent = this.labels[stage];
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.running = false;
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popo-story-watch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('popo-instagram-reel')) {
  customElements.define('popo-instagram-reel', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const load = () => {
        let script = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
        const process = () => window.instgrm?.Embeds?.process();
        if (window.instgrm?.Embeds) {
          process();
        } else if (script) {
          script.addEventListener('load', process, { once: true, signal });
        } else {
          script = document.createElement('script');
          script.src = 'https://www.instagram.com/embed.js';
          script.async = true;
          script.addEventListener('load', process, { once: true, signal });
          document.head.append(script);
        }
      };
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          load();
        }
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.observer = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poposoap-campaign-benefits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindBenefits = (root = document) => {
      const sections = root.matches?.('[data-pmd-benefits]') ? [root] : root.querySelectorAll('[data-pmd-benefits]');
      sections.forEach((section) => {
        if (section.dataset.pmdBenefitsBound === 'true') return;

        const track = section.querySelector('[data-pmd-benefits-track]');
        const progress = section.querySelector('[data-pmd-benefits-progress]');
        const previous = section.querySelector('[data-pmd-benefits-prev]');
        const next = section.querySelector('[data-pmd-benefits-next]');
        if (!track || !progress || !previous || !next) return;

        section.dataset.pmdBenefitsBound = 'true';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const mobileView = window.matchMedia('(max-width: 749px)');
        const autoplayEnabled = section.dataset.pmdBenefitsAutoplay === 'true';
        const autoplayInterval = Math.max(2500, Number(section.dataset.pmdBenefitsInterval) || 4000);
        let autoplayTimer = null;
        let autoplayPausedByUser = false;

        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const isScrollable = maximum > 4;
          const width = track.scrollWidth > 0 ? Math.min(100, (track.clientWidth / track.scrollWidth) * 100) : 100;
          const available = 100 - width;
          const left = maximum > 0 ? (track.scrollLeft / maximum) * available : 0;

          section.classList.toggle('is-scrollable', isScrollable);
          previous.disabled = !isScrollable || track.scrollLeft <= 4;
          next.disabled = !isScrollable || track.scrollLeft >= maximum - 4;
          progress.style.setProperty('--pmd-benefits-progress-width', `${width}%`);
          progress.style.setProperty('--pmd-benefits-progress-left', `${Math.max(0, Math.min(available, left))}%`);
        };

        const scrollByItem = (direction) => {
          const item = track.querySelector('.pmd-benefit');
          if (!item) return;
          const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          track.scrollBy({
            left: (item.getBoundingClientRect().width + gap) * direction,
            behavior: reduceMotion.matches ? 'auto' : 'smooth'
          });
        };

        const stopAutoplay = (pausedByUser = false) => {
          if (pausedByUser) autoplayPausedByUser = true;
          if (!autoplayTimer) return;
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (autoplayPausedByUser) return;
          if (!autoplayEnabled || !mobileView.matches || reduceMotion.matches) return;
          if (track.scrollWidth - track.clientWidth <= 4) return;

          autoplayTimer = window.setInterval(() => {
            const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
            if (maximum <= 4) return;
            if (track.scrollLeft >= maximum - 4) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              scrollByItem(1);
            }
          }, autoplayInterval);
        };

        previous.addEventListener('click', () => {
          stopAutoplay(true);
          scrollByItem(-1);
        });
        next.addEventListener('click', () => {
          stopAutoplay(true);
          scrollByItem(1);
        });
        track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
        track.addEventListener('pointerdown', () => stopAutoplay(true), { passive: true });
        track.addEventListener('focusin', () => stopAutoplay(true));
        section.addEventListener('mouseenter', () => stopAutoplay(true));
        if (mobileView.addEventListener) mobileView.addEventListener('change', startAutoplay);
        if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', startAutoplay);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => {
            update();
            startAutoplay();
          });
          observer.observe(track);
        } else {
          window.addEventListener('resize', () => {
            update();
            startAutoplay();
          });
        }

        update();
        startAutoplay();
      });
    };

    bindBenefits();
    document.addEventListener('shopify:section:load', (event) => bindBenefits(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poposoap-diy-project-gallery"] && !Shopify.designMode) return;
  try {
    function initDiyProjectHubs(){document.querySelectorAll('[data-diy-project-hub]').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';const events=new AbortController(),on=(el,type,fn)=>el.addEventListener(type,fn,{signal:events.signal});const cards=[...gallery.querySelectorAll('.diy-card')],tabs=[...gallery.querySelectorAll('.nav-tab')],toolbar=gallery.querySelector('.nav-toolbar'),trigger=gallery.querySelector('.mobile-filter-trigger'),current=gallery.querySelector('.filter-current'),count=gallery.querySelector('.filter-count'),empty=gallery.querySelector('.empty-state'),modal=gallery.querySelector('dialog'),frame=modal.querySelector('iframe'),external=modal.querySelector('.video-modal-external'),modalTitle=modal.querySelector('h3');let opener=null;function collapse(){toolbar.classList.remove('is-open');trigger.setAttribute('aria-expanded','false')}function filter(type){let n=0;tabs.forEach(t=>{const active=t.dataset.type===type;t.classList.toggle('active',active);t.setAttribute('aria-pressed',String(active));if(active)current.textContent=t.textContent.trim()});cards.forEach(c=>{c.hidden=type!=='all'&&!c.dataset.types.trim().split(/\s+/).includes(type);if(!c.hidden)n++});count.textContent=String(n);count.setAttribute('aria-label',n+' projects');empty.hidden=n>0;collapse()}tabs.forEach(t=>on(t,'click',()=>filter(t.dataset.type)));on(trigger,'click',()=>{const open=toolbar.classList.toggle('is-open');trigger.setAttribute('aria-expanded',String(open))});on(document,'click',e=>{if(!toolbar.contains(e.target))collapse()});on(document,'keydown',e=>{if(e.key==='Escape')collapse()});gallery.querySelectorAll('[data-collection-filter]').forEach(c=>on(c,'click',e=>{e.preventDefault();filter(c.dataset.collectionFilter);gallery.querySelector('.workshop-grid').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})}));function embed(value){try{const u=new URL(value),host=u.hostname.replace(/^www\./,''),id=host==='youtu.be'?u.pathname.slice(1):host==='youtube.com'?u.searchParams.get('v'):'';if(!id||!/^[-\w]{11}$/.test(id))return null;const result=new URL('https://www.youtube.com/embed/'+id);result.searchParams.set('rel','0');result.searchParams.set('playsinline','1');let t=u.searchParams.get('t')||u.searchParams.get('start')||'';if(t){const parts=[...t.matchAll(/(\d+)(h|m|s)/g)];const seconds=parts.length?parts.reduce((n,m)=>n+Number(m[1])*({h:3600,m:60,s:1}[m[2]]),0):Number(t);if(Number.isFinite(seconds)&&seconds>=0)result.searchParams.set('start',String(seconds))}return result.href}catch{return null}}gallery.querySelectorAll('.video-trigger').forEach(b=>on(b,'click',()=>{const url=embed(b.dataset.video);if(!url)return;opener=b;frame.src=url;modalTitle.textContent=b.dataset.title;external.href=b.dataset.video;modal.classList.add('is-open');modal.showModal();modal.querySelector('.video-modal-close').focus()}));modal.querySelectorAll('[data-video-close]').forEach(b=>on(b,'click',()=>modal.close()));on(modal,'close',()=>{modal.classList.remove('is-open');frame.removeAttribute('src');if(opener)opener.focus()});on(document,'shopify:block:select',e=>{if(!gallery.contains(e.target))return;filter('all')});on(document,'shopify:section:unload',e=>{if(e.target.contains(gallery)){if(modal.open)modal.close();events.abort()}});filter('all')})}initDiyProjectHubs();document.addEventListener('shopify:section:load',initDiyProjectHubs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poposoap-feature-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('poposoap-feature-tabs')) {
    class PoposoapFeatureTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index, true));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const selectedTab = event.target.closest('[role="tab"]');
          if (!selectedTab) return;
          const index = this.tabs.indexOf(selectedTab);
          if (index >= 0) this.selectTab(index, false);
        });
      }

      onKeydown(event, currentIndex) {
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;
        event.preventDefault();
        this.selectTab(nextIndex, true);
      }

      selectTab(index, focusTab) {
        const update = () => {
          this.tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });

          this.panels.forEach((panel, panelIndex) => {
            panel.hidden = panelIndex !== index;
          });
        };

        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          document.startViewTransition(update);
        } else {
          update();
        }

        const selectedTab = this.tabs[index];
        selectedTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (focusTab) selectedTab.focus({ preventScroll: true });
      }
    }

    customElements.define('poposoap-feature-tabs', PoposoapFeatureTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poposoap-pdp-process-steps"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ps-process]').forEach((section) => {
    if (section.dataset.psProcessReady === 'true') {
      return;
    }

    section.dataset.psProcessReady = 'true';

    const tabs = Array.from(section.querySelectorAll('[data-process-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-process-panel]'));
    const markers = Array.from(section.querySelectorAll('.ps-pdp-process__marker'));
    const stepButtons = Array.from(section.querySelectorAll('.ps-pdp-process__step-button'));
    const stepList = section.querySelector('.ps-pdp-process__step-list');
    const callout = section.querySelector('[data-process-callout]');
    const stage = section.querySelector('.ps-pdp-process__stage');
    const diagramWrap = section.querySelector('.ps-pdp-process__diagram-wrap');
    const diagramImage = section.querySelector('.ps-pdp-process__diagram img');
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
    let activeIndex = initialTab ? initialTab.dataset.processTab : null;

    if (!tabs.length || !panels.length || !activeIndex) {
      return;
    }

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function resetCalloutPosition() {
      if (!callout) {
        return;
      }

      callout.classList.remove('is-positioned', 'is-placement-left');
      callout.style.removeProperty('left');
      callout.style.removeProperty('top');
      callout.style.removeProperty('--ps-callout-arrow-y');
    }

    function getMarker(index) {
      return markers.find((marker) => marker.dataset.processTab === index);
    }

    function positionCallout(index) {
      if (!callout || !stage || !diagramWrap || !desktopQuery.matches) {
        resetCalloutPosition();
        return;
      }

      const marker = getMarker(index);

      if (!marker) {
        resetCalloutPosition();
        return;
      }

      const stageRect = stage.getBoundingClientRect();
      const diagramRect = diagramWrap.getBoundingClientRect();
      const markerRect = marker.getBoundingClientRect();
      const calloutWidth = callout.offsetWidth || 340;
      const calloutHeight = callout.offsetHeight || 190;
      const gap = 18;
      const padding = 12;
      const markerX = markerRect.left + markerRect.width / 2 - stageRect.left;
      const markerY = markerRect.top + markerRect.height / 2 - stageRect.top;
      const minLeft = diagramRect.left - stageRect.left + padding;
      const maxLeft = diagramRect.right - stageRect.left - calloutWidth - padding;
      const minTop = diagramRect.top - stageRect.top + padding;
      const maxTop = diagramRect.bottom - stageRect.top - calloutHeight - padding;
      let left = markerX + gap;
      let placeLeft = false;

      if (left > maxLeft) {
        left = markerX - calloutWidth - gap;
        placeLeft = true;
      }

      if (left < minLeft || maxLeft < minLeft) {
        left = markerX - calloutWidth / 2;
        placeLeft = false;
      }

      const clampedLeft = clamp(left, minLeft, Math.max(minLeft, maxLeft));
      const clampedTop = clamp(markerY - calloutHeight / 2, minTop, Math.max(minTop, maxTop));
      const arrowY = clamp(markerY - clampedTop, 22, Math.max(22, calloutHeight - 22));

      callout.style.left = `${Math.round(clampedLeft)}px`;
      callout.style.top = `${Math.round(clampedTop)}px`;
      callout.style.setProperty('--ps-callout-arrow-y', `${Math.round(arrowY)}px`);
      callout.classList.add('is-positioned');
      callout.classList.toggle('is-placement-left', placeLeft);
    }

    function scrollActiveStep(index) {
      if (desktopQuery.matches) {
        return;
      }

      const button = stepButtons.find((item) => item.dataset.processTab === index);

      if (button && stepList) {
        const maxLeft = Math.max(0, stepList.scrollWidth - stepList.clientWidth);
        const targetLeft = Math.min(
          Math.max(0, button.offsetLeft - ((stepList.clientWidth - button.offsetWidth) / 2)),
          maxLeft
        );

        if (typeof stepList.scrollTo === 'function') {
          stepList.scrollTo({ left: targetLeft, behavior: 'smooth' });
        } else {
          stepList.scrollLeft = targetLeft;
        }
      }
    }

    function setActive(index, options = {}) {
      tabs.forEach((tab) => {
        const active = tab.dataset.processTab === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const active = panel.dataset.processPanel === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      activeIndex = index;
      requestAnimationFrame(() => positionCallout(activeIndex));

      if (!options.skipScroll) {
        scrollActiveStep(index);
      }
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setActive(tab.dataset.processTab));

      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
          return;
        }

        const group = tab.classList.contains('ps-pdp-process__step-button') ? stepButtons : markers;
        const controlGroup = group.length ? group : tabs.filter((item, position, items) => items.findIndex((candidate) => candidate.dataset.processTab === item.dataset.processTab) === position);
        const currentIndex = controlGroup.findIndex((item) => item.dataset.processTab === tab.dataset.processTab);
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + direction + controlGroup.length) % controlGroup.length;

        event.preventDefault();
        controlGroup[nextIndex].focus();
        setActive(controlGroup[nextIndex].dataset.processTab);
      });
    });

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', () => positionCallout(activeIndex));
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(() => positionCallout(activeIndex));
    }

    window.addEventListener('resize', () => positionCallout(activeIndex));

    if (diagramImage) {
      if (diagramImage.complete) {
        positionCallout(activeIndex);
      } else {
        diagramImage.addEventListener('load', () => positionCallout(activeIndex), { once: true });
      }
    }

    setActive(activeIndex, { skipScroll: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poposoap-project-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('project-film')) customElements.define('project-film', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const dialog = this.querySelector('dialog'), video = this.querySelector('video');
    let trigger;
    const productImage = this.closest('.ps-project-page')?.querySelector('.ps-story-v3__product-image');
    if (productImage) productImage.sizes = '(min-width: 700px) 520px, calc(100vw - 80px)';
    this.querySelectorAll('[data-moment]').forEach(button => button.addEventListener('click', () => {
      this.querySelectorAll('[data-moment]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const still = this.querySelector('.ps-film__still');
      still.src = button.dataset.image; still.alt = button.dataset.alt;
      this.querySelector('.ps-film__caption').textContent = button.dataset.caption;
      const watch = this.querySelector('.ps-film__watch-moment');
      watch.dataset.watch = button.dataset.time;
      watch.querySelector('[data-watch-label]').textContent = 'Watch from ' + button.querySelector('small').textContent;
      watch.click();
    }));
    this.querySelectorAll('[data-watch]').forEach(button => button.addEventListener('click', () => {
      trigger = button;
      const time = Number(button.dataset.watch || 0);
      if (!video.src) video.src = this.dataset.video;
      const start = () => { video.currentTime = time; video.play().catch(() => {}); };
      if (video.readyState >= 1) start(); else video.addEventListener('loadedmetadata', start, { once: true });
      dialog.showModal();
      video.play().catch(() => {});
    }));
    this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { video.pause(); if (trigger) trigger.focus(); });
    video.addEventListener('error', () => { this.querySelector('.ps-film__video-error').hidden = false; });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps07-cauldron-story"] && !Shopify.designMode) return;
  try {
    
function initCauldronStory(root){
  if(root.dataset.cn07Ready)return;
  root.dataset.cn07Ready='true';
  const dialog=root.querySelector('dialog');
  const video=dialog.querySelector('video');
  let returnFocus=null;
  let requestedTime=0;
  video.addEventListener('error',()=>{dialog.querySelector('[data-cn07-error]').hidden=false;});
  const startFilm=()=>{if(dialog.open){video.currentTime=requestedTime;video.play().catch(()=>{});}};
  video.addEventListener('loadedmetadata',startFilm);
  const closeFilm=()=>{video.pause();if(dialog.open)dialog.close();};
  root.querySelectorAll('[data-cn07-film]').forEach(button=>button.addEventListener('click',()=>{
    returnFocus=button;
    requestedTime=Number(button.dataset.cn07Film)||0;
    dialog.showModal();
    if(video.readyState>=1)startFilm();else{video.src=video.dataset.cn07Src;video.load();video.play().catch(()=>{});}
    dialog.querySelector('[data-cn07-close]').focus();
  }));
  dialog.querySelector('[data-cn07-close]').addEventListener('click',closeFilm);
  dialog.addEventListener('cancel',()=>video.pause());
  dialog.addEventListener('close',()=>{video.pause();if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeFilm();}});
}
document.querySelectorAll('.cn07').forEach(initCauldronStory);
document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('.cn07');if(root)initCauldronStory(root);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps08-halloween-story"] && !Shopify.designMode) return;
  try {
    function initHalloweenStories(){document.querySelectorAll('.hw08').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const dialog=root.querySelector('dialog'),video=dialog.querySelector('video'),close=dialog.querySelector('[data-close]');let trigger=null,requestedTime=0;function seek(){if(dialog.open&&video.readyState>=1){video.currentTime=Math.min(requestedTime,Math.max(0,video.duration-.1))}}video.addEventListener('loadedmetadata',seek);root.querySelectorAll('[data-video-time]').forEach(button=>button.addEventListener('click',()=>{trigger=button;requestedTime=Math.max(0,Number(button.dataset.videoTime)||0);dialog.showModal();if(!video.getAttribute('src')){video.src=video.dataset.src;video.load()}seek();video.play().catch(()=>{});close.focus()}));close.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});dialog.addEventListener('close',()=>{video.pause();if(trigger)trigger.focus()});const checks=[...root.querySelectorAll('.task input')];checks.forEach(check=>check.addEventListener('change',()=>{root.querySelector('[data-progress]').textContent=checks.filter(c=>c.checked).length+' OF '+checks.length+' PLANNING STEPS CHECKED'}))})}initHalloweenStories();document.addEventListener('shopify:section:load',initHalloweenStories);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps09-pot-fountain-story"] && !Shopify.designMode) return;
  try {
    function initPotStories(){document.querySelectorAll('.fh09').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const dialog=root.querySelector('dialog'),video=dialog.querySelector('video'),close=dialog.querySelector('[data-close-video]');let lastTrigger=null,requested=0;function seek(){if(dialog.open&&video.readyState>=1)video.currentTime=Math.min(requested,Math.max(0,video.duration-.1))}video.addEventListener('loadedmetadata',seek);root.querySelectorAll('[data-open-video]').forEach(button=>button.addEventListener('click',()=>{lastTrigger=button;requested=Number(button.dataset.seconds)||0;dialog.showModal();if(!video.getAttribute('src')){video.src=video.dataset.src;video.load()}seek();video.play().catch(()=>{});close.focus()}));close.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});dialog.addEventListener('close',()=>{video.pause();if(lastTrigger)lastTrigger.focus()});const image=root.querySelector('#fh09-daynight-image'),label=root.querySelector('#fh09-daynight-image-label');root.querySelectorAll('[data-mode]').forEach(button=>button.addEventListener('click',()=>{const night=button.dataset.mode==='night';image.src=night?image.dataset.night:image.dataset.day;image.alt=night?'The real faeandhome pot fountain at dusk with its LED illuminated':'The finished pot fountain and solar panel in daylight';label.textContent=night?'THE GARDEN AT DUSK':'THE GARDEN BY DAY';root.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));root.querySelectorAll('.avatar img').forEach(img=>img.addEventListener('error',()=>{img.hidden=true}))})}initPotStories();document.addEventListener('shopify:section:load',initPotStories);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps10-stream-filter-story"] && !Shopify.designMode) return;
  try {
    
function initStreamStories(){document.querySelectorAll('.popo-diy-10').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const video=root.querySelector('video'),chapters=[...root.querySelectorAll('.chapter')],status=root.querySelector('.video-status');let requested=0;function seek(){if(video.readyState>=1){video.currentTime=Math.min(requested,Math.max(0,video.duration-.1))}}async function playAt(t,focus){requested=t;if(!video.getAttribute('src')){video.src=video.dataset.src;video.load()}seek();try{await video.play();status.hidden=true}catch(e){status.textContent='Use the play control in the film to start playback.';status.hidden=false}if(focus)video.focus({preventScroll:true})}video.addEventListener('loadedmetadata',seek);video.addEventListener('timeupdate',()=>{let chosen=null;chapters.forEach(c=>{if(video.currentTime>=Number(c.dataset.time))chosen=c});chapters.forEach(c=>c.setAttribute('aria-pressed',String(c===chosen)))});video.addEventListener('error',()=>{status.textContent='The film could not load. Use Open the film or the original Instagram Reel below.';status.hidden=false});const scope=root.closest('.fx10-page')||root;scope.addEventListener('click',event=>{const a=event.target.closest('a[href^="#"]');if(!a||!scope.contains(a))return;const target=document.getElementById(a.hash.slice(1));if(!target)return;event.preventDefault();event.stopPropagation();if(a.matches('.hero-photo-play,.hero-actions a[id]'))playAt(0,true);target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})},true);chapters.forEach(c=>c.addEventListener('click',()=>{playAt(Number(c.dataset.time),false);chapters.forEach(b=>b.setAttribute('aria-pressed',String(b===c)))}));let pond='decorative';const input=root.querySelector('.gallon-row input'),result=root.querySelector('.fit-result'),title=result.querySelector('strong'),note=result.querySelector('p');function fit(){const cap=pond==='fish'?600:1200;const raw=input.value,n=Number(raw);result.classList.remove('warning');if(!raw){title.textContent='Enter your pond volume';note.textContent='Listed maximums: 1,200 US gallons for decorative ponds; 600 US gallons for fish-stocked ponds.';return}if(!Number.isFinite(n)||n<=0||n>100000){title.textContent='Enter a positive volume up to 100,000 US gallons';note.textContent='Use your estimated pond volume to compare the published limits.';return}result.classList.toggle('warning',n>cap);title.textContent=n>cap?'Above the listed volume limit':'At or below the listed volume limit';note.textContent=n.toLocaleString()+' US gallons compared with the listed '+cap.toLocaleString()+'-gallon maximum for '+(pond==='fish'?'fish-stocked':'decorative')+' ponds. '+(n>cap?'Consider more filtration capacity.':'This does not confirm suitability. Check lift, fish load, tubing and the return route.')}root.querySelectorAll('[data-pond]').forEach(b=>b.addEventListener('click',()=>{pond=b.dataset.pond;root.querySelectorAll('[data-pond]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));fit()}));input.addEventListener('input',fit);fit()})}initStreamStories();document.addEventListener('shopify:section:load',initStreamStories);document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('.popo-diy-10 video').forEach(v=>v.pause())});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
(() => {
  const registry = window.__textWithIconsAutoplayRegistry || (window.__textWithIconsAutoplayRegistry = new Set());

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const startInstance = (instance) => {
    instance.stop();

    if (prefersReducedMotion() || !instance.carousel.isConnected) {
      return;
    }

    if (!instance.carousel.items?.length || (instance.carousel.totalPages || 1) < 2) {
      return;
    }

    instance.timer = window.setInterval(() => {
      if (!instance.carousel.isConnected) {
        instance.stop();
        registry.delete(instance);
        return;
      }

      const totalPages = instance.carousel.totalPages || 1;
      if (totalPages < 2) {
        return;
      }

      const nextIndex = (instance.carousel.selectedIndex + 1) % totalPages;
      instance.carousel.select(nextIndex, { animate: true, force: true });
    }, instance.delay);
  };

  const bindCarousel = (carousel) => {
    if (!carousel || carousel.dataset.textIconsAutoplayReady === 'true') {
      return;
    }

    carousel.dataset.textIconsAutoplayReady = 'true';

    const instance = {
      carousel,
      delay: Math.max(2500, Number(carousel.dataset.textIconsAutoplayDelay) || 4000),
      timer: null,
      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      },
      restart() {
        window.requestAnimationFrame(() => startInstance(this));
      }
    };

    registry.add(instance);

    carousel.addEventListener('pointerenter', () => instance.stop());
    carousel.addEventListener('pointerleave', () => startInstance(instance));
    carousel.addEventListener('focusin', () => instance.stop());
    carousel.addEventListener('focusout', () => startInstance(instance));
    carousel.addEventListener('touchstart', () => instance.stop(), { passive: true });
    carousel.addEventListener('scrollend', () => instance.restart());

    startInstance(instance);
  };

  const init = (root = document) => {
    root.querySelectorAll?.('[data-text-icons-autoplay]').forEach((carousel) => bindCarousel(carousel));
  };

  if (!window.__textWithIconsAutoplayPageBound) {
    window.__textWithIconsAutoplayPageBound = true;

    document.addEventListener('visibilitychange', () => {
      registry.forEach((instance) => {
        if (document.hidden) {
          instance.stop();
        } else {
          startInstance(instance);
        }
      });
    });

    window.addEventListener('resize', () => {
      registry.forEach((instance) => instance.restart());
    });
  }

  if (!window.__textWithIconsAutoplayInitBound) {
    window.__textWithIconsAutoplayInitBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-picks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".top-pick-card");

  cards.forEach(card => {
    const video = card.querySelector(".top-pick-video");
    const muteButton = card.querySelector(".mute-toggle");

    // Hover 自动播放
    if (video && video.tagName === 'VIDEO') {
      card.addEventListener("mouseenter", () => {
        video.currentTime = 0;
        video.play().catch(() => {});
      });
      card.addEventListener("mouseleave", () => {
        video.pause();
      });
    }

    // 音量按钮控制
    if (muteButton && video) {
      muteButton.addEventListener("click", () => {
        video.muted = !video.muted;
        muteButton.textContent = video.muted ? '🔇' : '🔊';
      });
    }

    // 移动端点击播放
    card.addEventListener("click", () => {
      if (window.innerWidth < 768 && video) {
        if (video.paused) video.play(); else video.pause();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
